import type { ErrorEvent } from '@sentry/browser';
import { init, replayIntegration, setTag, thirdPartyErrorFilterIntegration } from '@sentry/browser';
import { FeatureToggle, isFeatureEnabled } from '../../util/featureToggle';
import SentryErrorFilter from './SentryErrorFilter';
import ignoreErrors from '../../../../shared/sentry/ignoreErrors';
import denyUrls from '../../../../shared/sentry/denyUrls';

const filter = new SentryErrorFilter();

init({
    dsn: process.env.SENTRY_DSN,
    beforeSend: (event: ErrorEvent): ErrorEvent | null => {
        // Want to test beforeSend in development? Comment out the thirdPartyErrorFilterIntegration
        if (filter.shouldIgnore(event)) return null;
        return event;
    },
    allowUrls: [/https:\/\/assets\.nature\.house\/build\//],
    denyUrls,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    integrations: [
        replayIntegration(),
        thirdPartyErrorFilterIntegration({
            filterKeys: [process.env.SENTRY_APP_KEY ?? ''],
            behaviour: 'drop-error-if-exclusively-contains-third-party-frames'
        })
    ],
    ignoreErrors
});

const isLandlord = document.body.classList.contains('userIsLandlord');
setTag('is-landlord', isLandlord.toString());
setTag('deployment-environment', document.documentElement.dataset.deploymentEnv);

const featuresEnabled = Object.values(FeatureToggle)
    .map((feature): string => (isFeatureEnabled(feature) ? feature : ''))
    .filter(Boolean);

if (featuresEnabled.length) {
    setTag('features-enabled', featuresEnabled.join(','));
}
